import GoToAll from "components/shared/go-to-all";
import { productFormId } from "constants/config";
import ContentStatuses from "constants/content-statuses";
import { memo } from "react"

const ContentState = props => {
    const { data } = props;

    return (
        <div className="wrap-box tp-22 mb-4">
            <div className="financial-state">
                <div className="flex mb-2 items-center justify-between reset-i">
                    <h2 className="title tp-34">وضعیت محتوا</h2>
                    <GoToAll link={`/panel/content?form_id=${productFormId}`} />
                </div>

                <div className="max-h-48">
                    <ul>
                        {
                            ContentStatuses.map(status => (
                                <li key={`order-status-${status.id}`}>
                                    <div>
                                        <span className="sec-title tp-34">{status.title}</span>
                                    </div>

                                    <b className="tp-34">
                                        {data.data.content_status[productFormId] ? data.data.content_status[productFormId][status.id] || 0 : 0}
                                    </b>
                                </li>
                            ))
                        }
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default memo(ContentState);